// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the main calculator component for equity release calculations
import EquityReleaseCalculator from "../../frontend/components/calculators/EquityReleaseCalculator";

// Main page component for the Equity Release calculator
const EquityReleasePage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero
        title="Equity Release"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      {/* Render the Equity Release Calculator */}
      <EquityReleaseCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default EquityReleasePage;
